import React from "react";
import {Layout} from 'antd';
import PracticeListRoot from './PracticeListRoot'
import DisplayNumber from './containers/DisplayNumber'


import MainPage from './containers/MainPage';
import DetailPage from './DetailPage';
import PortfolioDetail from './PortfolioDetail';
import ReviewPage from './ReviewPage';
import Logout from './Logout'
import SignUpForm from './SignUpForm'
import SignUpFormProf from './SignUpFormProf'
import CreateRecord from './CreateRecord'
import ProfList from './ProfList'
import PortfolioList from './PortfolioList'
import ListPage from './ListPage'
import ExtractPage from './ExtractPage'
import ModifyRecord from './ModifyRecord'
import StudentList from './StudentList'
import VerifyEmail from './VerifyEmail'
import ForgotPassword from './ForgotPassword'
import ChangePassword from './ChangePassword'


import {Route, Switch} from 'react-router-dom';

const { Header, Content, Footer, Sider } = Layout;


export default class MainBody extends React.Component {
  state = {
  };

  render() {
    return (
    <Switch>
      <Route path='/index' component={() => <MainPage token={this.props.token} session={this.props.session} />}></Route>
      <Route exact path='/detail/:record_id' component={DetailPage}></Route>
      <Route exact path='/modify/:record_id' component={ModifyRecord}></Route>
      <Route exact path='/review/:record_id' component={ReviewPage}></Route>
      <Route path='/create/:primary_class' component={CreateRecord}></Route>
      <Route path='/create' component={CreateRecord}></Route>
      <Route exact path='/list' component={() => <ListPage  token={this.props.token} session={this.props.session}/>}></Route>
      <Route exact path='/extract' component={() => <ExtractPage token={this.props.token} session={this.props.session} />}></Route>
      <Route path='/sign_up' component={SignUpForm}></Route>
      <Route path='/sign_up_professor' component={SignUpFormProf}></Route>
      <Route path='/logout' component={Logout}></Route>
      <Route path='/verify_email' component={VerifyEmail}></Route>
      <Route path='/forgot_password' component={ForgotPassword}></Route>
      <Route path='/change_password' component={ChangePassword}></Route>
      <Route path='/prof_list/:state'  render={(props) => (
        <ProfList key={props.match.params.state} {...props}/>
      )}/>
      <Route exact path='/prof_list'  render={(props) => (
        <ProfList key={props.match.params.id} {...props}/>
      )}/>
      <Route exact path='/portfolio_list'  render={(props) => (
        <PortfolioList key={props.match.params.id} {...props}/>
      )}/>
      <Route exact path='/admin_list'  render={(props) => (
        <StudentList key={props.match.params.id} {...props}/>
      )}/>
      <Route exact path='/portfolio_detail/:portfolio_id' component={PortfolioDetail}></Route>
      <Route exact path='/' component={() => <MainPage  token={this.props.token} session={this.props.session}/>}></Route>

    </Switch>


    )
  }

}
